{% block prems_premium_item_iap_list %}
    <sw-card class="prems-premium-item-iap-list">
        {% block prems_premium_item_iap_list_banner %}
            <mt-banner
                class="prems-premium-item-iap-list__banner"
                variant="info">
                <span v-html="$tc('prems-premium-item.iap.update-marketing-text')"></span>
            </mt-banner>
        {% endblock %}

        {% block prems_premium_item_iap_list_content %}
            <sw-data-grid
                class="prems-premium-item-iap-list__data-grid"
                :header="true"
                :showSelection="false"
                :showActions="false"
                :data-Source="items"
                :columns="columns">
                {% block prems_premium_item_iap_list_content_columns %}
                    {% block prems_premium_item_iap_list_content_column_free %}
                        <template #column-free="{ item }">
                            <span v-if="isLastItem(item)">
                                <span v-if="!hideAdvancedButton">
                                    <strong>{{ $tc('prems-premium-item.iap.your-version') }}</strong>
                                </span>
                            </span>
                                <sw-data-grid-column-boolean
                                    v-if="isBoolean(item.free)"
                                    :value="item.free"
                                    :isInlineEdit="false">
                                </sw-data-grid-column-boolean>
                            <span v-else>
                                {{ item.free }}
                            </span>
                        </template>
                    {% endblock %}
                    {% block prems_premium_item_iap_list_content_column_advanced %}
                        <template #column-advanced="{ item }">
                            <span v-if="isLastItem(item)">
                                <span v-if="!hideAdvancedButton">
                                    <mt-button
                                        variant="primary"
                                        size="small"
                                        :isLoading="isLoading"
                                        @click="onClickBuyIapAdvanced">
                                        {{ $tc('prems-premium-item.iap.subscribe') }}
                                    </mt-button>
                                </span>
                                <span v-if="hideAdvancedButton">
                                    <b>{{ $tc('prems-premium-item.iap.your-version') }}</b>
                                </span>
                            </span>
                            <span v-else>
                                <sw-data-grid-column-boolean
                                    v-if="isBoolean(item.advanced)"
                                    :value="item.advanced"
                                    :isInlineEdit="false">
                                </sw-data-grid-column-boolean>
                                <span v-else>
                                    {{ item.advanced }}
                                </span>
                            </span>
                        </template>
                    {% endblock %}
                {% endblock %}
            </sw-data-grid>
        {% endblock %}
    </sw-card>
{% endblock %}